<template>
  <BaseModal
    :title="$t('message.memberGetMember.historyModal.title')"
    :subtitle="$t('message.memberGetMember.historyModal.subtitle')"
    :modal-width="modalWidth"
    :min-height="minHeight"
    hookSufix="HistoryMemberGetMember"
    disableDefaultPadding
    :paddingTop="'8px'"
    :fullscreen="isMobileBreakpoint"
  >
    <template #subtitle>
      <p
        class="body-regular-smaller neutral-40-light--text mb-0"
        :class="{
          'neutral-40-light--text': !$vuetify.theme.dark,
        }"
      >
        {{ $t('message.memberGetMember.historyModal.subtitle') }}
        <a
          :href="$t('message.memberGetMember.historyModal.knowMoreLink')"
          type="secondary"
          size="xsmall"
          class="body-bold-smaller neutral-30-base--text"
          target="_blank"
          >{{ $t('message.memberGetMember.historyModal.knowMore') }}
          <v-icon size="12" color="neutral-30-base">mdi-open-in-new</v-icon></a
        >
      </p>
    </template>
    <!-- <template #header>
      <v-toolbar elevation="0">
        <v-toolbar-title class="text--subtitle primary--text">
          <span>Extrato</span>
        </v-toolbar-title>

        <v-spacer />

        <v-toolbar-items>
          <v-btn icon @click="handleClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
    </template> -->
    <template #content>
      <div
        class="d-flex justify-center align-center"
        v-if="isLoading"
        style="min-height: 536px"
      >
        <v-card
          flat
          height="250px"
          class="d-flex flex-row align-center justify-center"
        >
          <loading-logo :value="200" />
        </v-card>
      </div>
      <div class="container-no-content" v-else-if="transactions.length == 0">
        <span class="body-regular-large">{{
          $t('message.memberGetMember.historyModal.emptyState')
        }}</span>
        <span class="body-regular-small neutral-40-light--text">
          {{ $t('message.memberGetMember.historyModal.emptyStateSubtitle') }}
        </span>
      </div>
      <div class="container-content" v-else>
        <div class="table-container">
          <div
            style="justify-content: space-between"
            class="d-flex w-full border-bottom pb-4 header-shadow"
            :class="{ active: hasShadow }"
            ref="header"
          >
            <div class="d-flex" style="gap: 132px">
              <span
                class="body-label-xs neutral-20-dark--text"
                style="padding-left: 24px"
              >
                {{ $t('message.memberGetMember.historyModal.date') }}
              </span>
              <span class="body-label-xs neutral-20-dark--text">
                {{ $t('message.memberGetMember.historyModal.description') }}
              </span>
            </div>
            <span
              class="body-label-xs neutral-20-dark--text"
              style="padding-right: 24px"
            >
              {{ $t('message.memberGetMember.historyModal.value') }}
            </span>
          </div>
          <div
            class="d-flex flex-column w-full container-list"
            ref="scrollContainer"
            @scroll="handleScroll"
          >
            <div
              v-for="(transaction, index) in transactions"
              :key="index"
              class="d-flex w-full"
              :class="{
                'border-top': index != 0,
              }"
              style="justify-content: space-between"
            >
              <div class="d-flex transaction-cols">
                <span
                  class="d-flex align-center body-regular-smaller py-4 neutral-40-light--text"
                >
                  {{ formatDate(transaction.created_at) }}
                </span>
                <div class="py-4">
                  <span
                    v-if="transaction.status == 'activated'"
                    style="gap: 4px"
                    class="d-flex align-center body-regular-smaller neutral-40-light--text description-text"
                    v-html="
                      $t(
                        'message.memberGetMember.historyModal.invitationEmail',
                        {
                          email: transaction.email,
                        }
                      )
                    "
                  >
                  </span>
                  <span
                    v-if="
                      transaction.limit_reached ||
                      transaction.status == 'limit_reached'
                    "
                    style="gap: 4px"
                    class="d-flex align-center body-regular-smaller neutral-40-light--text description-text"
                  >
                    {{
                      $t('message.memberGetMember.historyModal.limitReached')
                    }}
                  </span>
                </div>
              </div>
              <span
                class="d-flex align-center body-regular-smaller py-4 neutral-40-light--text"
                :class="{
                  'limit-reached':
                    transaction.limit_reached ||
                    transaction.status == 'limit_reached',
                }"
              >
                {{ userPlan.currency != 'brl' ? '$' : 'R$' }}
                {{ formatValue(transaction.amount) }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </BaseModal>
</template>
<script>
import { mask } from 'vue-the-mask'
import { mapState } from 'vuex'
import LoadingLogo from '@/components/LoadingLogo.vue'
import BaseModal from '@/components/BaseModal.vue'
// internal imports
import linkHelper from '@/utils/linkHelper.mixin.js'
// components

//mixins
import logoBonificationMixin from '@/utils/logoBonification.mixin.js'

export default {
  name: 'MemberGetMember',
  directives: { mask },
  props: {
    transactions: {
      type: Array,
      default: () => [],
    },
    currencySymbol: {
      type: String,
      default: 'R$',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BaseModal,
    LoadingLogo,
  },
  mixins: [linkHelper, logoBonificationMixin],
  data() {
    return {
      openModalPixel: false,
      hasShadow: false,
    }
  },
  computed: {
    ...mapState({
      userPlan: (state) => state.user.userPlanInfo,
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
      isPandaBrandingBonusEnabled: (state) =>
        state.user.isPandaBrandingBonusEnabled,
    }),
    minHeight() {
      return this.isMobileBreakpoint ? '100%' : ''
    },
    modalWidth() {
      return !this.isMobileBreakpoint ? '856px' : '100%'
    },
  },
  methods: {
    handleScroll() {
      const container = this.$refs.scrollContainer
      if (container) {
        this.hasShadow = container.scrollTop > 0
      }
    },
    getCurrentArticleLink() {
      return this.getArticleLink('memberGetMember')
    },
    formatDate(date) {
      const parsedDate = new Date(date)
      const day = String(parsedDate.getDate()).padStart(2, '0')
      const month = String(parsedDate.getMonth() + 1).padStart(2, '0')
      const year = parsedDate.getFullYear()
      const hours = String(parsedDate.getHours()).padStart(2, '0')
      const minutes = String(parsedDate.getMinutes()).padStart(2, '0')
      return `${day}/${month}/${year} (${hours}:${minutes})`
    },
    formatValue(value) {
      const valueFormatted = value?.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })
      return `${valueFormatted}`
    },
  },
  mounted() {
    this.transactions = this.transactions?.filter(
      (row) => row.status !== 'trialing'
    )
    this.$nextTick(() => {
      const container = this.$refs.scrollContainer
      if (container) {
        container.addEventListener('scroll', this.handleScroll)
      }
    })
  },
  beforeDestroy() {
    const container = this.$refs.scrollContainer
    if (container) {
      container.removeEventListener('scroll', this.handleScroll)
    }
  },
}
</script>
<style lang="scss" scoped>
.container-no-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 536px;
  border-top: 1px solid varFigma(neutral-95-lightest);
}
.container-content {
  display: flex;
  flex-direction: column;
  min-height: 536px;
  width: 100%;
  padding-top: 12px;
}
.container-list {
  padding: 0px 24px;
  max-height: 480px;
  overflow-y: auto;
}
.body-label-xs {
  color: varFigma(neutral-20-dark);
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
}
.w-full {
  width: 100%;
}
.border-bottom {
  border-bottom: 1px solid varFigma(neutral-95-lightest);
}
.border-top {
  border-top: 1px solid varFigma(neutral-95-lightest);
}
.header-shadow {
  position: relative;
}

.header-shadow::after {
  content: '';
  position: absolute;
  bottom: -16px;
  left: 0;
  right: 0;
  height: 16px;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.1), transparent);
  pointer-events: none;
  transition: opacity 0.2s ease-in-out;
  opacity: 0;
}
.container-content {
  display: flex;
  flex-direction: column;
  min-height: 536px;
  width: 100%;
  padding-top: 16px;

  @media (max-width: 768px) {
    // ou a breakpoint que você usa no projeto
    overflow-x: auto;
  }
}
.table-container {
  min-width: 800px; // ou o tamanho fixo que quiser
}
.header-shadow.active::after {
  opacity: 1;
}
.transaction-cols {
  display: flex;
  align-items: center;
}

.transaction-cols > span:first-child {
  min-width: 160px;
  flex-shrink: 0;
}
.limit-reached {
  text-decoration-line: line-through;
  color: varFigma(feedback-danger) !important;
}
.description-text {
  flex: 1;
}
</style>
